// Import: Middleware Action & Custom Types
import { CLEAN_BARRING_ACTION, CLEAN_BARRING_ACTION_ERROR } from '_models/redux/types';

// Action function
export const cleanBarringAction = () => async (dispatch) => {
  // Endpoint: Try & Catch

  try {
    dispatch({
      type: CLEAN_BARRING_ACTION,
      payload: [],
    });
  } catch (e) {
    dispatch({
      type: CLEAN_BARRING_ACTION_ERROR,
      payload: [],
    });
  }
};
